import { appendIFrame } from './Video';

const videoGalleries = document.querySelectorAll('.video__wrapper');
const isMobile = window.matchMedia('(max-width: 768px)').matches;

if (videoGalleries.length > 0) {
    let videos = [];

    videoGalleries.forEach(gallery => {
        videos.push(Array.from(gallery.querySelectorAll('.video')));
    });
    videos = videos.flat();
    
    videos.forEach(video => {
        video.addEventListener('click', (e) => {
            handleVideos(e);
        });

        video.addEventListener('keydown', e => {
            if (e.code === 'Enter') {
                handleVideos(e);
            }
        });
    });      
}

function togglePlayPause(video) {
    const parent = video.parentElement;
    const videos = parent.querySelectorAll('.video');

    videos.forEach(vid => { 
        vid.classList.remove('video--play');
        vid.classList.remove('video--pause');
    });

    video.classList.add('video--play');
}

function pauseVideo(video) {
    const iframe = document.querySelector('.video__container iframe');

    if (!iframe) {
        return;
    }

    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    
    video.classList.remove('video--play');
    video.classList.add('video--pause');
}

function playVideo(video) {
    const iframe = document.querySelector('.video__container iframe');
    iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    video.classList.add('video--play');
    video.classList.remove('video--pause');
}

function handleFirstVideo(currentVideo, lightbox) {
    if (currentVideo.querySelector('.video--vertical') || currentVideo.classList.contains('video--vertical')) {
        let firstVideo;
        if (lightbox) {
            firstVideo = lightbox.querySelectorAll('.video')[1];
            return firstVideo;
        } else {
            const videoGallery = currentVideo.parentElement.parentElement.querySelector('.video__gallery');
            firstVideo = videoGallery.querySelector('.video:not(.video--vertical)');

            if (!isMobile) {
                firstVideo.classList.add('video--play');
                firstVideo.classList.add('video--first');
            }
            
            return firstVideo;
        } 
    }
}

export function selectCurrentLightbox(event) {
    let lightbox;

    if (document.querySelector('.video-lightbox--open')) {
        lightbox = document.querySelector('.video-lightbox--open');
    }
    
    if (!lightbox && event) {
        const videoGallery = event.target.closest('.video__wrapper');
        if (videoGallery) {
            lightbox = videoGallery.querySelector('.video-lightbox');
        }
    }

    return lightbox;
} 

export function selectCurrentVideoGallery(event) {
    if (event) {
        return event.target.closest('.video__wrapper');
    }

    return null;
} 

export function handleVideos(event) {
    let currentVideo = event.currentTarget;
    const lightbox = selectCurrentLightbox(event);


    const firstVideo = handleFirstVideo(currentVideo, lightbox);
    if (firstVideo) {
        currentVideo = firstVideo;
    }

    if (!currentVideo) {
        return;
    }

    const videoId = currentVideo.getAttribute('data-youtube-id');

    if (!videoId && !currentVideo.classList.contains('video--vertical')) {
        return;
    }

    const player = currentVideo.parentElement.parentElement.parentNode.querySelector('.video__player')
    if (!player) {
        return;
    }
    const template = player.querySelector('.js-video-template');
    if (!template) {
        return;
    }

    let src = undefined;

    if (currentVideo.classList.contains('video--play') && !currentVideo.classList.contains('video--vertical video--play') && !firstVideo) {
        pauseVideo(currentVideo);
    } else if (currentVideo.classList.contains('video--pause')) {
        playVideo(currentVideo);
    } else {
        if (videoId !== null) {
            src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&loop=0&background=0&title=0&enablejsapi=1&controls=0&rel=0';
        }
        
        appendIFrame(template, src);
        togglePlayPause(currentVideo);
    }
}
